<template>
  <div class="footer_container">
    <div class="foot_top">
      <div class="foot_top_in">
        <div
          class="nav"
          v-for="(nav, index) in footNav"
          :key="index"
          @click="toPage(nav)"
        >
          <span class="name"> {{ nav.name }}</span>
        </div>
      </div>
    </div>
    <footer>
      <div class="footer-content">
        <div
          class="footer-column"
          v-for="(column, index) in footerColumns"
          :key="index"
        >
          <h3>{{ column.title }}</h3>
          <div
            class="detail_con2"
            :id="`foot${index}`"
            v-html="column.contact"
          ></div>
          <!-- <ul>
            <li v-for="(link, linkIndex) in column" :key="linkIndex">
              <span>{{ link.text }}</span>

              <span v-if="link.value">{{ link.value }}</span>
              <div class="img_con" v-if="link.img">
                <img v-for="(i, ind) in link.img" :src="i" :key="ind" />
              </div>
            </li>
          </ul> -->
        </div>
      </div>
      <div><span class="line"></span></div>
      <div class="copyright">
        <div class="detail_con2" v-if="detail" v-html="detail.contact5"></div>
        <div class="detail_con2" v-if="detail" v-html="detail.contact6"></div>
      </div>
    </footer>
    <el-dialog
      :visible.sync="previewVisible"
      width="40%"
      top="20vh"
      custom-class="image-preview-dialog"
    >
      <img
        :src="preImg"
        style="
          max-width: 100%;
          max-height: 80vh;
          display: block;
          margin: 0 auto;
        "
      />
    </el-dialog>
  </div>
</template>

<script>
import { getColumnAll } from '@/const';
import { getPageObj } from '@/assets/api';
export default {
  name: 'Footer',
  data() {
    return {
      preImg: '',
      previewVisible: false,
      currentYear: new Date().getFullYear(),
      cloumnList: [],
      footNav: [
        { name: '新闻资讯', accessPath: '/news' },
        { name: '交通信息', accessPath: '' },
        { name: '剧场介绍', accessPath: '' },
        { name: '纪念品', accessPath: '' },
      ],
      detail: {},
      footerColumns: [
        {
          title: this.$t('contactUs'),
          contact: '',
        },
        {
          title: this.$t('supportUs'),
          contact: '',
          links: [
            { text: '商务合作' },
            { text: '邮箱:', value: 'contact@wuzhenfestival.cn' },
            { text: '微信客服:', value: 'wuzhen_festival' },
          ],
        },
        {
          title: this.$t('followUs'),
          contact: '',
          links: [
            { text: '@乌镇戏剧节' },
            // {
            //   text: '',
            //   img: [
            //     require('@/assets/img/foot_icon1.png'),
            //     require('@/assets/img/foot_icon2.png'),
            //     require('@/assets/img/foot_icon3.png'),
            //     require('@/assets/img/foot_icon4.png'),
            //     require('@/assets/img/foot_icon5.png'),
            //     require('@/assets/img/foot_icon6.png'),
            //     require('@/assets/img/foot_icon7.png'),
            //     require('@/assets/img/foot_icon8.png'),
            //   ],
            // },
          ],
        },
        {
          title: this.$t('friendshipLink'),
          contact: '',
          links: [
            { text: '乌镇旅游官网', path: 'contact@.cn' },
            { text: '乌镇旅游预定网', path: 'contact@.cn' },
          ],
        },
      ],
    };
  },
  computed: {
    navTree() {
      return this.$store.state.navTree;
    },
  },
  watch: {
    navTree(newVal, oldVal) {
      this.cloumnList = newVal;
      this.getFoot();
    },
  },
  mounted() {
    this.cloumnList = this.$store.state.navTree;
    this.getFoot();
    this.getColumnList();
    this.$nextTick(() => {
      this.$el
        .querySelector('#foot2')
        .addEventListener('click', this.handleClick);
    });
  },
  // 在 beforeDestroy 中移除事件监听
  beforeDestroy() {
    this.$el
      .querySelector('#foot2')
      .removeEventListener('click', this.handleClick);
  },
  methods: {
    // 检查是否是图片链接
    isImageUrl(url) {
      return /\.(jpe?g|png|gif|webp|bmp|svg)(\?.*)?$/i.test(url);
    },
    handleClick(event) {
      const link = event.target.closest('a'); // 获取被点击的最近的 <a> 元素

      if (link) {
        event.preventDefault(); // 阻止默认跳转行为
        if (this.isImageUrl(link.href)) {
          this.previewVisible = true;
          this.preImg = link.href;
        } else {
          window.location.href = link.href;
        }
      }
    },
    getColumnList() {
      const navObj = getColumnAll();
      this.footNav = navObj.footNav;
    },
    toPage(nav) {
      this.$router.push({
        path: nav.accessPath,
        query: { cloumnId: nav.id },
      });
    },
    getFoot() {
      let id = '';
      this.cloumnList.map((c) => {
        if (c.accessPath == '/foot') {
          id = c.id;
        }
      });
      getPageObj(id).then((res) => {
        if (res.code == 200) {
          this.detail = res.data;
          this.footerColumns.map((f, index) => {
            if (index == 0) {
              f.title = this.$t('contactUs');
            }
            if (index == 1) {
              f.title = this.$t('supportUs');
            }
            if (index == 2) {
              f.title = this.$t('followUs');
            }
            if (index == 3) {
              f.title = this.$t('friendshipLink');
            }
            f.contact = this.detail[`contact${index + 1}`];
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.footer_container {
  color: white;
}
.foot_top {
  padding: 0 6.25%;
  background: linear-gradient(90deg, #aae5ef 0%, #b1bbff 100%);
  height: 4rem;
  line-height: 4rem;
  .foot_top_in {
    display: flex;
    justify-content: flex-start;
  }
  .nav {
    position: relative; /* 为伪元素定位做准备 */
    font-size: 1.125rem;
    color: #333333;
    font-family: SourceHanSansCN-Medium;
    display: flex;
    align-items: center;
    cursor: pointer;
    min-width: 5.75rem;
    padding: 0 1.25rem; /* 左右内边距 */
    .name {
      flex: 1;
      text-align: center; /* 文字改为居中 */
    }
  }
  .nav:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 1px;
    height: 16px;
    background: #333;
  }
}
footer {
  width: 100%;
  background-color: #424451;
  padding: 2.5rem 6.25%;
  box-sizing: border-box;
  .line {
    display: inline-block;
    width: 100%;
    height: 1px;
    background: #ffffff;
    margin: 20px auto 20px;
  }
}
.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
}

.footer-column {
  h3 {
    margin-bottom: 1.5rem;
    font-size: 1.375rem;
    text-align: left;
    font-family: SourceHanSansCN-Medium;
  }
  ul {
    list-style: none;
    li {
      margin-bottom: 0.8rem;
      text-align: left;
      display: flex;
      font-size: 1.125rem;
      color: rgba(255, 255, 255, 0.8);
      .img_con {
        display: grid;
        grid-template-columns: repeat(4, minmax(2rem, 1fr));
        img {
          width: 2rem;
          height: 2rem;
          margin-right: 1.25rem;
          margin-bottom: 0.75rem;
        }
      }
    }
  }
}

.copyright {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  div {
    text-align: left; /* 确保文字左对齐 */
  }
  :nth-child(2) {
    text-align: right; /* 确保文字左对齐 */
  }
}

@media screen and (max-width: 500px) {
  .footer_container {
    .foot_top {
      .foot_top_in {
        display: flex;
      }
      .nav {
        flex: 1;
        font-size: 1.125rem;
        color: #333333;
        font-family: SourceHanSansCN-Medium;
        display: flex;
        align-items: center;
        .name {
          flex: 1;
          text-align: center;
        }
        .line {
          width: 1px;
          background: #333;
          height: 16px;
        }
      }
    }
  }
}
::v-deep {
  .detail_con1 {
    color: #fff !important;
    font-size: 1.125rem !important;
    font-family: SourceHanSansCN-Normal !important;
    line-height: 2.5rem !important;
    p,
    span,
    strong {
      color: #fff !important;
      font-size: 1.125rem !important;
      font-family: SourceHanSansCN-Normal !important;
      line-height: 2.5rem !important;
    }
  }
}
</style>
